import art from "./art.jpg";

export default {
    root: {
        height: "100vh"
    },
    image: {
        backgroundImage: `url(${art})`,
        backgroundRepeat: "no-repeat",
        backgroundColor: "#fafafa",
        backgroundSize: "cover",
        backgroundPosition: "center"
    },
    paper: {
        margin: "64px 32px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
    },
    avatar: {
        margin: "8px",
        backgroundColor: "#f50057"
    },
    form: {
        width: "100%", // Fix IE 11 issue.
        marginTop: "8px"
    },
    submit: {
        margin: "24px 0 16px"
    }
};
